// @flow
/* ***************************************************************************
* @author mfranco (mfranco@mobinteg.com)
* @author mbarbosa (mfranco@mobinteg.com)
*******************************************************************************/

import React, { Component } from "react"
import style from "./style.css"
import Card from "../../components/Card"
import Spacer from "../../components/Spacer"
import Dropdown from "react-toolbox/lib/dropdown/Dropdown"
import Autocomplete from "react-toolbox/lib/autocomplete"
import { withRouter } from "react-router-dom"
import * as strings from "../../strings"
import Input from "react-toolbox/lib/input/Input"
import DatePicker from "../../components/DatePicker"
import _ from "lodash"

class LitigationDetails extends Component {
  props: {
    onChange: () => any,

    suggestions: any,
    litigation: any,
    history: any,
    token: string,
  }

  handleChange = ( name, isToRound ) => value => {
    if ( !this.props.onChange ) {
      return
    }

    this.props.onChange( {
      ...this.props.litigation,
      [ name ]: !_.isEqual( value, "" ) ? ( isToRound ? _.round( value, 2 ) : value ) : null,
    } )
  }

  render () {
    const courtSource = _.get( this.props, "suggestions.courts", [] )
      .reduce( ( acc, court ) => ( {
        ...acc,
        [ court.id ]: court.name,
      } ), {} )

    const requestSource = [
      { value: null, label: "" },
      ..._.get( this.props, "suggestions.injunctionRequests", [] )
        .map( v => ( {
          label: v.name,
          value: v.id,
        } ) ),
    ]

    const requestCauseSource = [
      { value: null, label: "" },
      ..._.get( this.props, "suggestions.injunctionRequestCauses", [] )
        .map( v => ( {
          label: v.name,
          value: v.id,
        } ) ),
    ]


    const { litigation } = this.props
    return (
      <div className={style.root}>
        <div className={style.row}>
        </div>
        <Spacer size={2} />
        <Card decor className={style.bottomCard}>
          <div className={style.litigationDetailsGrid}>
            <Input
              label={strings.generalStrings.idc}
              value={litigation.idc}
              onChange={this.handleChange( "idc", false )}
              type="text"
            />
            <Input
              label={strings.processes.injunctionNumber}
              value={litigation.injunctionNumber}
              onChange={this.handleChange( "injunctionNumber", false )}
              type="text"
            />
            <DatePicker
              icon={"date_range"}
              label={strings.generalStrings.litigationEntryDate}
              value={litigation.litigationEntryDate ? new Date( litigation.litigationEntryDate ) : undefined}
              onChange={this.handleChange( "litigationEntryDate", false )}
            />
            <Dropdown
              label={strings.generalStrings.segment}
              source={[ {
                value: null,
                label: "Sem segmento",
              }, {
                value: "B2B",
                label: "B2B",
              }, {
                value: "B2C",
                label: "B2C",
              } ]}
              value={litigation.segment}
              onChange={this.handleChange( "segment", false )}
            />
            <Input
              label={strings.paymentAgreements.capitalValue}
              value={litigation.litigationCapitalValue}
              onChange={this.handleChange( "litigationCapitalValue", true )}
              type="number"
              step="0.01"
              min="0.00"
            />
            <Input
              label={strings.paymentAgreements.interest}
              value={litigation.interest}
              onChange={this.handleChange( "interest", false )}
              type="number"
              step="0.01"
              min="0.00"
            />
            <Input
              label={strings.paymentAgreements.interestRate}
              value={litigation.interestRate}
              onChange={this.handleChange( "interestRate", true )}
              type="number"
              step="0.01"
              min="0.00"
            />
            <Input
              label={strings.paymentAgreements.justiceTax}
              value={litigation.justiceTax}
              onChange={this.handleChange( "justiceTax", true )}
              type="number"
              step="0.01"
              min="0.00"
            />
            <DatePicker
              icon={"date_range"}
              label={strings.generalStrings.interestDate}
              value={litigation.interestDate ? new Date( litigation.interestDate ) : undefined}
              onChange={this.handleChange( "interestDate", false )}
            />
            <Input
              label={strings.processes.executoryFormulaReference}
              value={litigation.executoryFormulaReference}
              onChange={this.handleChange( "executoryFormulaReference", false )}
              type="text"
            />
            <Autocomplete
              showSuggestionsWhenValueIsSet={true}
              direction="down"
              className={ style.courtField }
              multiple={false}
              label={strings.execution.court}
              onChange={this.handleChange( "idCourt", false )}
              source={courtSource}
              value={litigation.idCourt}
              suggestionMatch="anywhere"
            />
            <Input
              label={strings.paymentAgreements.section}
              value={litigation.section}
              onChange={this.handleChange( "section", false )}
              type="text"
            />
            <Input
              label={strings.paymentAgreements.service}
              value={litigation.service}
              onChange={this.handleChange( "service", false )}
              type="text"
            />
            <Dropdown
              label={strings.generalStrings.request}
              className={style.requestField}
              value={litigation.idInjunctionRequest}
              onChange={this.handleChange( "idInjunctionRequest", false )}
              source={requestSource}
            />
            <Dropdown
              label={strings.generalStrings.requestCause}
              value={litigation.idInjunctionRequestCause}
              onChange={this.handleChange( "idInjunctionRequestCause", false )}
              source={requestCauseSource}
            />
            <Input
              type="text"
              label={strings.generalStrings.observations}
              className={style.observationsField}
              multiline
              maxLength={1000}
              value={_.get( this.props, "litigation.observations" )}
              onChange={this.handleChange( "observations", false )}
            />
          </div>
        </Card>
      </div>
    )
  }
}

export default withRouter( LitigationDetails )



// WEBPACK FOOTER //
// ./src/components/LitigationDetails/index.jsx